/**
 * 商品ページ メインギャラリー: モバイルのみ Embla カルーセルで制御。
 *
 * - Dawn ネイティブの slider-component スクロール挙動＋独自ドットJSを置き換える。
 * - viewport = <slider-component id="GalleryViewer-*">、container = ul.product__media-list、slides = li.product__media-item。
 * - モバイル(<=749px)でのみ init、PC幅では destroy して CSS の縦積みレイアウトへ戻す。
 * - prev/next ボタンは Dawn のリスナーを剥がすため clone してから Embla を接続。
 * - ドットは Embla の scrollSnapList を元に生成（.product__media-dots / .product__media-dot / .is-active）。
 */
(function () {
  var MOBILE = '(max-width: 749px)';
  var instances = new WeakMap(); // gallery -> { destroy }

  function buildDots(gallery, viewport, embla) {
    var existing = gallery.querySelector('.product__media-dots');
    if (existing) existing.remove();

    var snaps = embla.scrollSnapList();
    if (snaps.length < 2) return null;

    var dotsRow = document.createElement('div');
    dotsRow.className = 'product__media-dots';

    snaps.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product__media-dot';
      b.setAttribute('aria-label', i + 1 + ' / ' + snaps.length);
      b.addEventListener('click', function () {
        embla.scrollTo(i);
      });
      dotsRow.appendChild(b);
    });

    viewport.insertAdjacentElement('afterend', dotsRow);
    return dotsRow;
  }

  var lumCache = {}; // src+side -> luminance(0-255)

  // 画像の左端/右端の縦ストリップ（中央高さ付近）の平均輝度を返す。CORS等で取得不可なら null。
  function stripLuminance(img, side) {
    var natW = img.naturalWidth;
    var natH = img.naturalHeight;
    if (!natW || !natH) return null;
    try {
      var cw = 16;
      var ch = 32;
      var c = document.createElement('canvas');
      c.width = cw;
      c.height = ch;
      var ctx = c.getContext('2d');
      var sw = Math.max(1, Math.round(natW * 0.15));
      var sx = side === 'left' ? 0 : natW - sw;
      var sh = Math.round(natH * 0.3);
      var sy = Math.round(natH * 0.35);
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);
      var data = ctx.getImageData(0, 0, cw, ch).data;
      var sum = 0;
      var n = 0;
      for (var i = 0; i < data.length; i += 4) {
        sum += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        n++;
      }
      return n ? sum / n : null;
    } catch (e) {
      return null; // canvas taint（CORS）等
    }
  }

  // 現在スライド画像の左右端の明るさから、アロー色（.arrow-dark）を左右個別に切り替える。
  function updateArrowContrast(viewport, slide) {
    if (!slide) return;
    var img = slide.querySelector('img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;

    function applyFor(side) {
      var sel = side === 'left' ? '.slider-button--prev' : '.slider-button--next';
      var btn = viewport.querySelector(sel);
      if (!btn) return;
      var key = src + '|' + side;
      var apply = function (lum) {
        if (lum == null) return; // 判定不可時は既定（白＋影）のまま
        btn.classList.toggle('arrow-dark', lum > 140);
      };
      if (key in lumCache) {
        apply(lumCache[key]);
        return;
      }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var lum = stripLuminance(probe, side);
        lumCache[key] = lum;
        apply(lum);
      };
      probe.onerror = function () {
        lumCache[key] = null;
      };
      probe.src = src;
    }

    applyFor('left');
    applyFor('right');
  }

  function initGallery(gallery) {
    if (instances.has(gallery)) return;
    if (typeof window.EmblaCarousel === 'undefined') return;

    var viewport = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewport) return;
    var container = viewport.querySelector('.product__media-list');
    if (!container) return;
    if (container !== viewport.firstElementChild) {
      // Embla は viewport の最初の子を container とみなすため先頭へ移動
      viewport.insertBefore(container, viewport.firstElementChild);
    }
    var slides = container.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;

    gallery.classList.add('embla-active');

    var embla = window.EmblaCarousel(viewport, {
      loop: false,
      align: 'center',
      containScroll: 'trimSnaps',
      dragFree: false,
      duration: 22,
    });

    var dotsRow = buildDots(gallery, viewport, embla);

    function update() {
      var idx = embla.selectedScrollSnap();
      if (dotsRow) {
        dotsRow.querySelectorAll('.product__media-dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }
      var prev = viewport.querySelector('.slider-button--prev');
      var next = viewport.querySelector('.slider-button--next');
      if (prev) prev.disabled = !embla.canScrollPrev();
      if (next) next.disabled = !embla.canScrollNext();
      updateArrowContrast(viewport, slides[idx]);
    }

    // prev/next: Dawn のクリックハンドラを剥がすため clone してから Embla を接続
    viewport.querySelectorAll('.slider-buttons .slider-button').forEach(function (btn) {
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);
      var isPrev = clone.classList.contains('slider-button--prev');
      clone.addEventListener('click', function (e) {
        e.preventDefault();
        if (isPrev) embla.scrollPrev();
        else embla.scrollNext();
      });
    });

    embla.on('select', update);
    embla.on('reInit', update);
    update();

    instances.set(gallery, {
      destroy: function () {
        try { embla.destroy(); } catch (e) {}
        gallery.classList.remove('embla-active');
        var d = gallery.querySelector('.product__media-dots');
        if (d) d.remove();
      },
    });
  }

  function destroyGallery(gallery) {
    var inst = instances.get(gallery);
    if (inst) {
      inst.destroy();
      instances.delete(gallery);
    }
  }

  function apply() {
    var isMobile = window.matchMedia(MOBILE).matches;
    document.querySelectorAll('.product__media-wrapper media-gallery').forEach(function (g) {
      if (isMobile) initGallery(g);
      else destroyGallery(g);
    });
  }

  function run() {
    apply();
    var mq = window.matchMedia(MOBILE);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // テーマエディタでのセクション再読込に対応
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('.product__media-wrapper media-gallery').forEach(function (g) {
      destroyGallery(g);
    });
    apply();
  });
})();
